import { Stroke, Style } from "ol/style";

export function getDefaultStyleNormal(feature) {
  return getDefaultColorStyle(feature);
}
export function getDefaultStyleClick(feature) {
  return getDefaultColorStyle(feature, true, false);
}
export function getDefaultStyleHover(feature) {
  return getDefaultColorStyle(feature, false, true);
}
export function getDefaultColorStyle(feature, click, hover) {
  let color, width, backgroundColor, backgroundWidth;

  color = "grey";
  backgroundColor = "white";
  width = 2;
  backgroundWidth = 4;
  if (hover || click) {
    return [
      new Style({
        stroke: new Stroke({
          color: backgroundColor,
          width: backgroundWidth,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: color,
          width: width,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];
}
